import { Component, input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CapitalCard } from "@commons/capital-card/capital-card";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-home-options-element',
  imports: [CapitalCard, CommonModule],
  templateUrl: './home-options-element.html',
  styleUrl: './home-options-element.scss',
})
export class HomeOptionsElement {
  private readonly router = inject(Router);
  
  title = input<string>("");
  caption = input<string>("");
  action = input<string>("");
  icon = input<string>("");
  route = input<string>("");
  isLoading = input<boolean>(false);

  onClick() {
    if (this.isLoading()) {
      return; // No navegar si está cargando
    }
    const routePath = this.route();
    if (routePath) {
      this.router.navigate([routePath]);
    }
  }
}
